import * as React from 'react';
import styled from 'styled-components';
import { colors, rawColors } from './colors/color';
import { Icon, iconName } from './icons/Icons';
import { CountAvatar } from './avatar/CountAvatar';

export type TabberVariant = 'button' | 'text';
export type TabberAlignment = 'left' | 'right' | 'center' | 'stretch';

export type TabItem2 = {
    tabName:string,
    icon?:iconName,
    avatarCount?:number,
    text:string,
    disabled?:boolean,
    hidden?:boolean
}

export type Tabber2Props = {
    variant:TabberVariant,
    alignment?:TabberAlignment,
    selectedTabName?:string,
    items:TabItem2[],
    onClick?:(tabName:string)=>void
}
export function Tabber2(props:Tabber2Props):JSX.Element
{
    function handleClickTab(item:TabItem2)
    {
        props.onClick?.(item.tabName);
    }

    const styleVariant = props.variant || 'button';

    const alignment = props.alignment || 'stretch';

    let justifyContent = 'stretch';
    if(alignment === 'center') justifyContent = 'center';
    if(alignment === 'left') justifyContent = 'flex-start';
    if(alignment === 'right') justifyContent = 'flex-end';

    const buttons = props.items.filter(t => !t.hidden).map(t => 
        <button 
            key={t.tabName} 
            data-selected={t.tabName === props.selectedTabName} 
            disabled={!!t.disabled}
            onClick={() => handleClickTab(t)}>
            {t.icon && 
                <Icon name={t.icon} size="small" />
            }
            <span style={{marginRight:t.avatarCount ? '4px' : '0'}}>
                {t.text}
            </span>
            {t.avatarCount !== undefined &&
                <CountAvatar count={t.avatarCount} />
            }
        </button>
    );

    return (
        
        <div style={{display:'flex', justifyContent}}> 
            {/* div wrapper is needed for new line - inner container is inline-flex */}

            {styleVariant === 'button' && buttons &&
                <ButtonStyledTabContainer alignment={alignment}>
                    {buttons}
                </ButtonStyledTabContainer>
            }

            {styleVariant === 'text' && buttons &&
                <TextStyledTabContainer alignment={alignment}>
                    {buttons}
                </TextStyledTabContainer>
            }

        </div>
    );
}

// Mark selected button with data-selected="true" attribute
const ButtonStyledTabContainer = styled.div<{alignment:TabberAlignment}>`
    display:${props => props.alignment === 'stretch' ?  'flex' : 'inline-flex'};
    width: ${({alignment}) => alignment === 'stretch' ? '100%' : 'auto'};
    align-items: center;
    padding: 4px;
    border: 1px solid ${colors.tabber2.button.border};
    background-color: ${rawColors.gray.lightExtreme};
    border-radius: 4px;
    gap: 4px;

    button {
        flex-grow: ${props => props.alignment === 'stretch' ? 1 : 0};
        border:1px solid transparent;
        display:flex;
        gap: 4px;
        align-items:center;
        justify-content: center;
        min-height: 34px; // Must be set since icons are slightly larger than avatars and would increase height otherwise for only some buttons
        letter-spacing: 0.5px;
        border-radius: 4px;
        padding: 12px 24px;
        font-size: 16px;

        font-weight:300;
        cursor:pointer;
        color: ${colors.text.gray.normal};
        background-color: ${rawColors.gray.lightExtreme};
        
        svg {
            fill:${colors.text.gray.normal};
        }
        
        &[data-selected="true"] {
            background-color: ${rawColors.white};
            color: ${colors.text.gray.dark};
            svg {
                fill: ${colors.text.gray.dark};
            }
            border:1px solid rgb(222,222,222);
            //box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        }
        &:hover:not([data-selected="true"]):not(:disabled) {
            background-color: ${rawColors.white};
            border:1px solid rgb(222,222,222);
        }
        &:disabled {
            cursor: default;
            color:${colors.tabber.colorDisabled};
            svg {
                fill: ${colors.text.gray.light};
            }
            background-color: ${rawColors.gray.lightExtreme};
        }
    }
`;

const TextStyledTabContainer = styled(ButtonStyledTabContainer)`
    background-color: transparent;
    border:none;
    padding: 0px;

    button {
        background-color: transparent;
        border-radius: 0px;
        border: none;
        border-bottom: 3px solid transparent;
        font-weight: 500;
        color: ${colors.text.gray.dark};
        line-height: 20px;
        font-weight: 500;
        font-size: 14px;
        box-shadow: none;

        &[data-selected="true"] {
            background-color: transparent;
            border: none;
            border-bottom: 3px solid ${rawColors.blue.normal};
            box-shadow: none;
        }
        &:hover:not([data-selected="true"]):not(:disabled) {
            background-color: transparent;
            border: none;
            border-bottom: 3px solid ${rawColors.blue.normal};
            box-shadow: none;
        }
        &:disabled {
            background-color: transparent;
            color: ${colors.text.light};
            border: none;
            border-bottom: 3px solid transparent;
            box-shadow: none;
        }
    }
`;